import React, { useState } from 'react';

export default function NotaFiscalImportForm() {
    const [files, setFiles] = useState<FileList | null>(null);
    const [loading, setLoading] = useState(false);
    const [resultados, setResultados] = useState<any[] | null>(null);
    const [erro, setErro] = useState<string | null>(null);

    const enviar = async () => {
        if (!files || files.length === 0) {
            setErro('Selecione ao menos um arquivo XML.');
            return;
        }
        setLoading(true);
        setErro(null);
        setResultados(null);
        try {
            const fd = new FormData();
            Array.from(files).forEach((f) => fd.append('files[]', f));

            const resp = await fetch(
                `${process.env.REACT_APP_API_ENDPOINT}/?route=notafiscal/importar&action=importar`,
                { method: 'POST', body: fd, credentials: 'include' }
            );
            const data = await resp.json();

            if (Array.isArray(data.payload)) {
                setResultados(data.payload);
            } else if (!data.success) {
                setErro(data.message || 'Falha na importação.');
            }
        } catch (e: any) {
            setErro(e?.message || 'Erro ao enviar os arquivos.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: 20, maxWidth: 820 }}>
            <h3>Importar NF-e de Entrada (XML)</h3>
            <p className="text-muted">
                Selecione um ou mais arquivos XML de NF-e de fornecedores. O sistema cadastra/referencia os
                produtos (de-para por fornecedor) e lança o estoque de entrada.
            </p>

            <input type="file" accept=".xml,text/xml" multiple onChange={(e) => setFiles(e.target.files)} />

            <div style={{ marginTop: 12 }}>
                <button className="btn btn-primary" disabled={loading} onClick={enviar}>
                    {loading ? 'Importando...' : 'Importar'}
                </button>
            </div>

            {erro && <div style={{ marginTop: 12, color: '#dc3545' }}>{erro}</div>}

            {resultados && (
                <table className="table" style={{ marginTop: 16, width: '100%' }}>
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'left' }}>Arquivo</th>
                            <th style={{ textAlign: 'left' }}>Resultado</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resultados.map((r: any, i: number) => (
                            <tr key={i}>
                                <td>{r.arquivo}</td>
                                <td style={{ color: r.success ? '#198754' : '#dc3545' }}>
                                    {r.success ? `OK (nota #${r.notaId})` : r.message}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
